// @ts-ignore
export const debounce = (fn, ms) => {
  // @ts-ignore
  let timer

  return () => {
    // @ts-ignore
    clearTimeout(timer)
    timer = setTimeout(() => {
      // @ts-ignore
      timer = null

      // @ts-ignore
      fn.apply(this, arguments)
    }, ms)
  }
}
